import { useState } from "react";
import { useApi } from "../useApi.js";
import { dateDe } from "../api.js";
import type { AuditRow } from "../types.js";
import { Page, Pill } from "../components/Shell.js";
import { TableSkeleton } from "../components/Skeleton.js";

export default function Audit() {
  const { data, error, loading } = useApi<AuditRow[]>("/api/audit?limit=300");
  const [q, setQ] = useState("");

  const list = (data ?? []).filter(
    (a) => !q || `${a.action}${a.subject}${a.detail}${a.actor}`.toLowerCase().includes(q.toLowerCase()),
  );

  return (
    <Page title="Historie"
          sub={data ? `${data.length} Einträge · lückenlos und unveränderlich` : undefined}
          actions={<input className="srch" placeholder="Ereignis, Beleg, Benutzer…"
                          value={q} onChange={(e) => setQ(e.target.value)} />}>
      {loading && <div className="card"><TableSkeleton widths={[15, 25, 40, 15]} /></div>}
      {error && <div className="empty">{error}</div>}
      {data && (
        <div className="card"><div className="tbl-wrap"><table>
          <thead><tr><th className="r">Datum</th><th>Vorgang</th><th>Bezug</th><th>Benutzer</th></tr></thead>
          <tbody>
            {list.length === 0
              ? <tr><td colSpan={4}><div className="empty">Keine Einträge.</div></td></tr>
              : list.map((a) => (
                <tr key={a.id}>
                  <td className="r num" style={{ width: "1%", whiteSpace: "nowrap" }}>{dateDe(a.at)}</td>
                  <td style={{ width: "1%" }}><Pill status="mute">{a.action}</Pill></td>
                  <td><b className="mono">{a.subject}</b><div className="sub-t">{a.detail}</div></td>
                  <td className="sub-t">{a.actor}</td>
                </tr>
              ))}
          </tbody>
        </table></div></div>
      )}
    </Page>
  );
}
